import { graphql } from 'react-relay';

export const ValidateConvertPageToMarkdownModeQuery = graphql`
	query ValidateConvertPageToMarkdownModeQuery($cloudId: ID!, $contentId: ID!) {
		confluence_validateConvertPageToMarkdownMode(cloudId: $cloudId, contentId: $contentId) {
			isLossless
		}
	}
`;
